<template>
	<div class="alert alert-info widget-block">
		<multiselect
			v-model="curValue"
			:options="curList"			
			:showLabels="false"			
			:allowEmpty="false"
			label="name"
			track-by="id"
			placeholder=""
			@open="OnOpen"
			@input="OnSelect"
			/>
		<button class="btn-close-filter close" @click.stop="closeFilter">×</button>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Multiselect from 'vue-multiselect'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterDisk',
	//=========================================================================
	// свойства
	//=========================================================================
	props: ['value', 'items'],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			curValue: { id: '-1', name: this.localeFtc('main/list_all') },
			curList: [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}],
			validTypes: ['16', '17'],
			// DOM-блок со списком
			$ulBlock: null
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		// инициализация списка
		this.initList()
	},
	//=========================================================================
	// компонент успешно примонтирован в DOM
	//=========================================================================
	mounted() {
		// если блок еще остался - удалим его
		if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove()

		// найдем врапер текущего поля
		let $component = $(this.$el)
		if (!$component.length) return

		// найдем блок со списком
		this.$ulBlock = $component.find('ul:first').parent()
		if (!this.$ulBlock.length) return

		// пропишем жестко стиль блоку
		let _css = {
			'position': 'absolute',
			'display': 'none',
			'width': 'calc(100% - 24px)',
			'z-index': 99
		}
		// хватает ли места внизу
		let hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight
		if (!hasEnoughSpace)
		{
			$component.addClass('multiselect--above')
			_css['margin-bottom'] = '-10px'
		}

		this.$ulBlock.css(_css)

		// переместим его наружу (в конец врапера)
		this.$ulBlock.detach().appendTo($component)

		// если задано значение
		this.setValue(this.value)
	},
	//=========================================================================
	// меотоды
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// установка значения
		//---------------------------------------------------------------------
		setValue(value) {
			this.curValue = { id: '-1', name: this.localeFtc('main/list_all') }

			if (value) {
				if (typeof value === 'object' && 'id' in value) {
					this.curValue = { id: String(value.id), name: '' }
				} else if (typeof value === 'string') {
					this.curValue = { id: value, name: '' }
				}

				if (this.curValue.id !== '-1') {
					if (this.items && this.items.length) {
						this.items.some(v => {
							if (v && String(v.id) === this.curValue.id) {
								this.curValue.name = this.localeFtc(v.name)
								return true
							}
						})
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// инициализация списка
		//---------------------------------------------------------------------
		initList() {
			// список по умолчанию
			this.curList = [{
				'id': '-1',
				'name': this.localeFtc('main/list_all')
			}]

			// если задан список
			if (this.items)
			{
				// если он сразу задан в виде массива
				if (Array.isArray(this.items))
				{
					this.items.forEach(item => {
						if (item && item.id && this.validTypes.indexOf(String(item.id)) > -1) {
							this.curList.push({
								'id': String(item.id),
								'name': this.localeFtc(item.name)
							})
						}
					})
				}
				else
				{
					// задан виде объекта - конвертируем в массив
					for (let _id in this.items)
					{
						if (_id && this.validTypes.indexOf(String(_id)) > -1) {
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(this.items[_id])
							})
						}
					}
				}
			}
		},

		//---------------------------------------------------------------------
		// выбрали значение
		//---------------------------------------------------------------------
		OnSelect(e) {
			// сообщим родителям что значение поменялось
			this.curValue = {
				id: String(e.id),
				name: this.localeFtc(e.name)
			}
			this.$emit('input', this.curValue.id)
		},

		//---------------------------------------------------------------------
		// открыли список
		//---------------------------------------------------------------------
		OnOpen() {
			if (!this.$ulBlock.data('start-position')) return
			this.$ulBlock.data('start-position', false)

			this.$nextTick(() => {
				setTimeout(() => {
					let sp = $('span.multiselect__option--selected:first')
					if (!sp.length) return

					let li = sp.parent()
					if (!li.length) return

					let h = li.height()
					let top = li.position().top - h

					if (top < 0) top = 0
					else
					{
						if ((top - h) >= 0) top -= h
						if ((top - h) >= 0) top -= h
						if ((top - h) >= 0) top -= h
					}
					this.$ulBlock.scrollTop(top)
				}, 100)
			})
		},

		//---------------------------------------------------------------------
		// закрытие фильтра
		//---------------------------------------------------------------------
		closeFilter() {
			this.$emit('closeFilter')
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдение за значением
	//=========================================================================
	watch: {
		'value': function(newValue) {
			this.setValue(newValue)
		},
		'items': function() {
			this.initList()
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: { Multiselect }

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.widget-block {
	min-width: 300px;
	font-size: 12px;
	padding: 3px 16px 4px 8px;
}

div.widget-block.not-close {
	padding: 3px 8px 4px 8px;
}

@media screen and (max-width: 767px) {
	div.widget-block {
		margin-bottom: 20px;
		width: 100%;
	}

	div.widget-block label {
		display: block;
		margin-left: 20px;
		padding: 10px 0;
	}
}

</style>



// WEBPACK FOOTER //
// filterDisk.vue?4cbc90a6